import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20modern%20fashion%20and%20lifestyle%20flat%20lay%20photography%20with%20designer%20handbag%20leather%20wallet%20stylish%20watch%20and%20premium%20accessories%20arranged%20on%20cream%20marble%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20high-end%20commercial%20style%2C%20warm%20neutral%20beige%20tonal%20palette%2C%20airy%20sophisticated%20composition%20with%20subtle%20texture&width=1600&height=900&seq=hero-main-2026-v2&orientation=landscape"
          alt="AllChinaBuy Spreadsheet featured products and trusted sellers directory"
          title="Best AllChinaBuy Spreadsheet 2026 - Product Directory"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/28 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full container-page py-20 md:py-24">
        <div className="max-w-3xl">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-50/30 text-background-50 text-xs md:text-sm font-medium mb-5 backdrop-blur-sm">
            Updated Daily &bull; 5,000+ Products &bull; 300+ Verified Sellers
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.08] mb-5 text-balance">
            Best AllChinaBuy<br />
            Spreadsheet 2026
          </h1>

          <p className="text-base md:text-lg text-background-50/85 max-w-xl mb-8 leading-relaxed">
            The largest updated AllChinaBuy Spreadsheet directory online. Discover thousands of trusted products, verified sellers, QC guides, shipping tutorials, and regularly updated AllChinaBuy spreadsheets.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-3">
            <div ref={dropdownRef} className="relative w-full sm:w-auto">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="w-full sm:w-auto flex items-center justify-between gap-2 px-6 py-3.5 bg-background-50 text-foreground-900 rounded-xl text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span>Browse Categories</span>
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isDropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-72 bg-background-50 rounded-xl border border-background-200/80 overflow-hidden z-20 animate-fade-in">
                  <div className="max-h-[380px] overflow-y-auto py-2">
                    {categories.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
                        onClick={() => setIsDropdownOpen(false)}
                      >
                        <div className="w-8 h-8 flex-shrink-0 rounded-md overflow-hidden">
                          <img src={cat.image} alt={cat.name} className="w-full h-full object-cover" loading="lazy" />
                        </div>
                        {cat.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-6 py-3.5 bg-primary-500 text-background-50 rounded-xl text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors flex items-center justify-center gap-1.5"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line text-xs"></i>
            </a>

            <Link
              to="/articles/shopping-guide-2026"
              className="w-full sm:w-auto px-6 py-3.5 bg-white/15 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-xl text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-white/25 transition-colors flex items-center justify-center gap-1.5"
            >
              Shopping Guide
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}